export default "__VITE_ASSET__Bqm0MtSP__"